import "./style.css";
import "maplibre-gl/dist/maplibre-gl.css";
import maplibregl from "maplibre-gl";
import { Map } from "maplibre-gl";
import { Protocol } from "pmtiles";

let protocol = new Protocol();
maplibregl.addProtocol("pmtiles", protocol.tile);

const map = new Map({
  container: "map",
  bounds: [9, 80.6, 33, 76.5],
  style: "https://tiles.openfreemap.org/styles/liberty",
});

map.on("load", () => {
  map.addSource("traces", {
    type: "vector",
    url: "pmtiles://traces.pmtiles",
    attribution:
      '<a href="https://zenodo.org/records/10407266">Calving Front Dataset: <img src="https://zenodo.org/badge/DOI/10.5281/zenodo.10407266.svg"></img></a>',
  });

  map.addLayer({
    id: "traces-layer",
    type: "line",
    source: "traces",
    "source-layer": "traces",
    paint: {
      "line-width": 2,
      "line-color": [
        "interpolate-lab",
        ["linear"],
        ["get", "year_frac"],
        1985.0,
        ["rgb", 239, 248, 33],
        1988.8,
        ["rgb", 252, 206, 37],
        1992.6,
        ["rgb", 252, 166, 53],
        1996.4,
        ["rgb", 242, 132, 75],
        2000.2,
        ["rgb", 224, 100, 97],
        2004.0,
        ["rgb", 202, 70, 120],
        2007.8,
        ["rgb", 176, 42, 143],
        2011.6,
        ["rgb", 143, 13, 163],
        2015.4,
        ["rgb", 106, 0, 167],
        2019.2,
        ["rgb", 64, 3, 156],
        2023.0,
        ["rgb", 12, 7, 134],
      ],
    },
  });
});

// map.on('load', () => {
//   let resetTime = false;
//   document.addEventListener('visibilitychange', () => {
//     resetTime = true;
//   });
//   let startTime = performance.now();
//   let layer = map.style.getLayer('traces');
//
//   function animate() {
//     let timestamp = performance.now();
//     if (resetTime) {
//       // resume previous progress
//       startTime = timestamp;
//       resetTime = false;
//     }
//     let progress = timestamp - startTime;
//
//     // restart if it finishes a loop
//     let time = 1985 + (progress / 50) % (2023 - 1985);
//     console.log('t', time);
//     map.setPaintProperty('traces', 'line-color', ['rgba', 255, 0, 0,
//         ['max', 0, ['-', 1, ['/', ['abs', ['-', ['get', 'year_frac'], time]], 2]]]]);
//     // Request the next frame of the animation.
//     requestAnimationFrame(animate);
//   }
//   animate();
// });
